import { render } from "./StagePage.vue?vue&type=template&id=44c13bf2&scoped=true"
import script from "./StagePage.vue?vue&type=script&lang=js"
export * from "./StagePage.vue?vue&type=script&lang=js"

import "./StagePage.vue?vue&type=style&index=0&id=44c13bf2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c13bf2"]])

export default __exports__